import { createAsyncThunk } from "@reduxjs/toolkit";
import { usersApi, type CreateUserRequest, type UpdateUserRequest } from "@template/api";
import type { RootState } from "../store";
import {
  userAdded,
  userRemoved,
  userUpdated,
  usersLoaded,
  usersRequestFailed,
  usersRequestStarted,
} from "./users.slice";

function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}

export const fetchUsers = createAsyncThunk<void, void, { state: RootState }>(
  "users/fetchUsers",
  async (_, { dispatch }) => {
    dispatch(usersRequestStarted());
    try {
      const users = await usersApi.list();
      dispatch(usersLoaded(users));
    } catch (err) {
      dispatch(usersRequestFailed(errorMessage(err)));
      throw err;
    }
  },
);

export const createUser = createAsyncThunk<void, CreateUserRequest, { state: RootState }>(
  "users/createUser",
  async (payload, { dispatch }) => {
    const user = await usersApi.create(payload);
    dispatch(userAdded(user));
  },
);

export const updateUser = createAsyncThunk<
  void,
  { id: string; payload: UpdateUserRequest },
  { state: RootState }
>("users/updateUser", async ({ id, payload }, { dispatch }) => {
  const user = await usersApi.update(id, payload);
  dispatch(userUpdated(user));
});

export const deleteUser = createAsyncThunk<void, string, { state: RootState }>(
  "users/deleteUser",
  async (id, { dispatch }) => {
    await usersApi.remove(id);
    dispatch(userRemoved(id));
  },
);
